<template>
  <div class="row" v-if="selected_task.epic_links">
    <div class="col-12">
      <select multiple placeholer="Set epic links"  :ref="'epicLinkSelect'+this.unique_id" :id="'epicLinkSelect'+this.unique_id" v-model="selected_task.epic_links" v-select="selected_task.epic_links" class="form-control form-control-sm mb-2"  style="overflow: auto" data-toggle="select">
        <option v-for="(epic_link, index) in epic_links.filter(epic_link_object => epic_link_object.project_id === selected_task.project_id) "
                :value="epic_link._id" :selected="epic_link._id in selected_task.epic_links" :key="index">
          {{epic_link.emoji}} {{epic_link.name}}
        </option>
      </select>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'epicLinksSelect',
    props: {

    },
    data: function () {
      return {
        unique_id: 'no',
      };
    },
    computed: {
      ...mapGetters([
        'account',
        'selected_account_id',
        'selected_project_id',
        'selected_task',
        'epic_links',
      ]),
    },
    watch: {
      // task_options: function (new_val, old_val) {
      //     if (this.$refs.epicLinkSelect) {
      //         this.$refs.epicLinkSelect.trigger('change')
      //     }
      // },
      // selected_project_id: function (new_val, old_val) {
      //     if (this.$refs.epicLinkSelect) {
      //         this.$refs.epicLinkSelect.trigger('change')
      //     }
      // },
      selected_task: function () {
        if (this.selected_task) {
          if (!this.selected_task.epic_links) {
            this.selected_task.epic_links = [];
          }
          this.enableSelect();
        }
      },
    },
    methods: {
      enableSelect () {
        const self = this;
        function initSelect ($this) {
          var options = {
            // eslint-disable-next-line no-undef
            dropdownParent: $this.closest('.modal').length ? $this.closest('.modal') : $(document.body),
            minimumResultsForSearch: $this.data('minimum-results-for-search'),
            templateResult: formatAvatar,
          };
          $this
            .select2(options)
            .val(self.selected_task.epic_links || []);
          // .on('change', function () {
          //     console.log(this.value);
          //     self.task.epic_links = [this.value]
          // });
        }

        function formatAvatar (avatar) {
          if (!avatar.id) {
            return avatar.text;
          }
          // eslint-disable-next-line no-undef
          var $option = $(avatar.element);
          var optionAvatar = $option.data('avatar-src');
          var optionPosition = $option.data('position');
          var output;
          if (!optionPosition) {
            optionPosition = '';
          } else if (optionPosition.length > 20) {
            optionPosition = optionPosition.slice(0, 17) + '...';
          }
          if (optionAvatar) {
            // eslint-disable-next-line no-undef
            output = $('<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="' + optionAvatar + '" alt="..."></span><span>' + avatar.text + '</span><span class="text-muted float-right">' + optionPosition + '</span>');
          } else { output = avatar.text; }
          return output;
        }
        // eslint-disable-next-line no-undef
        setTimeout(() => initSelect($(document.getElementById('epicLinkSelect' + self.unique_id))), 1);
      },
    },
    created () {
      this.unique_id = Math.random().toString();
      this.enableSelect();
    },

  };
</script>

<style>
.select2-selection--multiple {
  height: auto !important;
}

</style>
